var React = require('react');

function ParkingInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("rect",{"width":"22","height":"22","x":"1","y":"1","stroke":"currentColor","strokeLinecap":"square","strokeLinejoin":"round","strokeWidth":"2","rx":"2","key":0}),React.createElement("path",{"fill":"currentColor","d":"M12.031 7C14.288 7 16 8.318 16 10.44c0 2.075-1.712 3.517-3.969 3.517h-1.364l.01 3.043H8V7h4.031zm.016 2.273h-1.37v2.348h1.37c.747 0 1.23-.47 1.23-1.182 0-.697-.483-1.166-1.23-1.166z","key":1})]));
}

ParkingInline.defaultProps = {"width":"24","height":"24"};

module.exports = ParkingInline;

ParkingInline.default = ParkingInline;
